var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPlayL48Filled = function SvgIconPlayL48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.97 36.3 16.6-9.8c.89-.53 1.43-1.46 1.43-2.5s-.53-1.97-1.43-2.5l-16.6-9.79c-.89-.53-2.01-.54-2.91-.02-.9.52-1.46 1.48-1.46 2.52v19.6c0 1.04.56 2 1.46 2.52.9.52 2.02.51 2.91-.02v-.01Z",
    fill: "current"
  })));
};
export default SvgIconPlayL48Filled;